module.exports = __webpack_public_path__ + "img/norway-img.6551cc5.webp";